import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import fockeSmartDesign from '../assets/images/focke_smart_design.png';
import { styles } from '../styles';

const NotFoundView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleContactSupport = () => {
    window.open('https://serviceportal.focke.com/de/login', '_blank');
  };

  return (
    <div className={styles.notFound.container}>
      {/* Background Image - Smaller and Centered */}
      <div 
        className={styles.notFound.backgroundImage}
        style={{
          backgroundImage: `url(${fockeSmartDesign})`,
          backgroundSize: '60%'
        }}
      ></div>
      
      {/* Light overlay for better text readability */}
      <div className={styles.notFound.backgroundOverlay}></div>

      {/* FOCKE & CO Logo - Top Left */}
      <div className={styles.notFound.logo.container}>
        <img 
          src="/images/FOCKE-Logo.svg" 
          alt="FOCKE & CO" 
          className={styles.notFound.logo.image}
        />
      </div>

      {/* Main Content - Centered */}
      <div className={styles.notFound.content.container}>
        <div className={styles.notFound.content.wrapper}>
          {/* Title */}
          <h1 className={styles.notFound.content.title}>
            {t('notFoundTitle')}
          </h1>
          
          {/* Subtitle */}
          <p className={styles.notFound.content.subtitle}>
            {t('notFoundMessage')}
          </p>

          {/* Large 404 without background frame */}
          <div className={styles.notFound.content.errorNumber.container}>
            {/* Large 404 number - directly on background */}
            <h2 className={styles.notFound.content.errorNumber.text}>
              404
            </h2>
          </div>

          {/* Description */}
          <p className={styles.notFound.content.description}>
            {t('notFoundSubMessage')}
          </p>

          {/* Action Buttons */}
          <div className={styles.notFound.content.actions.container}>
            <button
              onClick={handleGoHome}
              className={styles.notFound.content.actions.primaryButton}
            >
              {t('goToPerformanceCockpit')}
            </button>
            <button
              onClick={handleContactSupport}
              className={styles.notFound.content.actions.secondaryButton}
            >
              {t('contactSupport')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundView;
